export default "__VITE_ASSET__BYC8bsNN__"